module.exports = __webpack_public_path__ + "93bb5b43bc1200beae66d7eb5039df02.svg";